<template>
  <div id="results">
    <Results></Results>
  </div>
</template>

<script>
import Results from '@/components/Results';

export default {
  name: 'PageResults',
  components: {
    Results,
  },
};
</script>
